import { render, staticRenderFns } from "./HpStairs.vue?vue&type=template&id=1ad68ec7&scoped=true&"
import script from "./HpStairs.vue?vue&type=script&lang=js&"
export * from "./HpStairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad68ec7",
  null
  
)

export default component.exports